<template>
    <div class="disease-science" v-loading="loading">
        <p v-if="chartData.diseaseName" class="disease-name">当前疾病：{{ chartData.diseaseName }}</p>
        <section
            v-for="item in visibleSections"
            :id="item.id"
            :key="item.key"
            class="science-section"
        >
            <div class="section-head">
                <h3 class="section-tit">{{ item.title }}</h3>
            </div>
            <div class="section-body">
                <doctor-recommendation v-if="item.key === 'expert'" :doctors="chartData.top10DoctorRecommendation" />
                <symptom-manifestation v-else-if="item.key === 'symptom'" :chart-data="chartData" />
                <nursing-care v-else-if="item.key === 'nursing'" :chart-data="chartData" />
            </div>
        </section>
    </div>
</template>

<script>
import SymptomManifestation from './comps/symptom_manifestation.vue';
import NursingCare from './comps/nursing_care.vue';
import DoctorRecommendation from './comps/doctor_recommendation.vue';
import { getEducationInfo } from '@/io/api';
import { normalizeScienceData, SCIENCE_CHART_TYPES, SCIENCE_TAG_TYPES } from './scienceData';

export default {
    name: 'DiseaseScience',
    components: { SymptomManifestation, NursingCare, DoctorRecommendation },
    props: {
        // 父组件也可直接传入业务响应的 data；不传时调用 io/api.js 的请求入口。
        scienceData: { type: Object, default: null },
    },
    data() {
        return {
            loading: false,
            responseData: {},
            requestId: 0,
            sections: [
                { key: 'expert', id: 'expertKnowledge', title: '医家知识' },
                { key: 'symptom', id: 'symptomManifestation', title: '症状表现' },
                { key: 'nursing', id: 'nursingCare', title: '护理调养' },
            ],
        };
    },
    computed: {
        visibleSections() {
            const data = this.chartData;
            const visible = {
                expert: data.top10DoctorRecommendation.length > 0,
                symptom: data.symptomKnowledgeGraph.nodes.length > 0 || data.symptomSankey.data.length > 0,
                nursing: data.nursingKnowledgeGraph.nodes.length > 0 ||
                    [...SCIENCE_CHART_TYPES, ...SCIENCE_TAG_TYPES].some(({ field }) => data[field].length > 0),
            };
            return this.sections.filter((item) => visible[item.key]);
        },
        chartData() {
            return normalizeScienceData(this.scienceData || this.responseData);
        },
    },
    watch: {
        scienceData: {
            immediate: true,
            handler(data) {
                if (data) {
                    this.requestId += 1;
                    this.loading = false;
                } else {
                    this.loadScienceData();
                }
            },
        },
        '$route.query.word'() {
            if (!this.scienceData) this.loadScienceData();
        },
    },
    beforeDestroy() {
        this.requestId += 1;
    },
    methods: {
        async loadScienceData() {
            const requestId = ++this.requestId;
            this.loading = true;
            this.responseData = {};
            try {
                // 按当前疾病名称查询；请求地址与参数统一维护在 src/io/api.js。
                // 这里接收 { code, msg, data }，子组件只接收规范化后的 data。
                const response = await getEducationInfo({ diseaseName: this.$route.query.word || '' });
                const { code, data, msg } = response.data || {};
                // 疾病快速切换、外部数据接管或组件销毁后，忽略旧请求。
                if (requestId !== this.requestId) return;
                if (Number(code) !== 0) {
                    this.$message.error(msg || '科普模块数据加载失败');
                    return;
                }
                this.responseData = data || {};
            } catch (error) {
                if (requestId !== this.requestId) return;
                this.$message.error(error.message || '科普模块数据加载失败，请稍后重试');
            } finally {
                if (requestId === this.requestId) this.loading = false;
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import './index.less';
.disease-name {
    margin: 0 0 16px;
    color: #0C55AA;
    font-weight: bold;
}
</style>
